<template>
    <div>
      <national-patent-authority-list></national-patent-authority-list>
    </div>
  </template>
  <script>
  export default {
  }
  </script>
